import React from 'react';
import Dialog from 'src/components/common/Dialog.redesign';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IConfirmDeleteContractOwnershipDialogProps {
    entityName: string;
    confirmDelete: () => void;
    cancelDelete: () => void;
}

const ConfirmDeleteContractOwnershipDialog = (props: IConfirmDeleteContractOwnershipDialogProps) => {
    return (
        <Dialog title="Confirm Delete">
            <div style={{ textAlign: 'center', fontSize: '2rem' }} className="mb-2">
                Are you sure want to permanetly delete this {props.entityName}?
            </div>
            <div style={{ textAlign: 'center' }}>
                <Button text="Confirm" onClick={props.confirmDelete} className="mr-2" intent="primary" />
                <Button text="Cancel" onClick={props.cancelDelete} intent="danger" />
            </div>
        </Dialog>
    );
};

export default ConfirmDeleteContractOwnershipDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/ConfirmDeleteDialog.tsx